import { Container } from "react-bootstrap";
import Carousel from "react-bootstrap/Carousel";
import "./ComCarousel.css"; // Import the CSS file

function ComCarousel() {
  return (
    <Container className="down-margin">
      <Carousel>
        <Carousel.Item>
          <img
            className="d-block w-100 carousel-image"
            src="/assets/images/commercial1.jpg"
            alt="First slide"
            style={{ borderRadius: "25px" }}
          />
          <Carousel.Caption>
            <h3>First Resident</h3>
            <p>
              This is my 1st commercial project i made. this is located at ...
            </p>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100 carousel-image"
            src="/assets/images/commercial2.jpg"
            alt="Second slide"
            style={{ borderRadius: "25px" }}
          />
          <Carousel.Caption>
            <h3>Second Resident</h3>
            <p>
              This is my 2nd commercial project i made. this is located at ...
            </p>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100 carousel-image"
            src="/assets/images/commercial3.jpg"
            alt="Third slide"
            style={{ borderRadius: "25px" }}
          />
          <Carousel.Caption>
            <h3>Third Resident</h3>
            <p>
              This is my 3rd commercial project i made. this is located at ...
            </p>
          </Carousel.Caption>
        </Carousel.Item>
      </Carousel>
    </Container>
  );
}

export default ComCarousel;
